import { fetchData } from './fetchData';
import { DefaultResponseData } from './data/DefaultResponseData';

export type FrontVodCreateRequestData = {
    // LINE ID
    line_uid: string,
    // 帳號
    login: string,
    // 主分類
    main_category: string,
    // 細項分類
    sub_category: string,
    // 問題
    question: string,
};

function frontVodCreate(data: FrontVodCreateRequestData): Promise<DefaultResponseData> {
    return fetchData('api/front_vod_create', {
        method: 'POST',
        body: JSON.stringify(data),
    })
        .then((res) => res.json())
        .then((resData: DefaultResponseData) => resData);
}

export { frontVodCreate };
